import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { Children, useMemo } from 'react';
import { getValidChild } from '@helpers';
import { StyledModalContainer } from './modal.styles';
import { ModalButtons } from './slots/modal-buttons';
import { ModalContent } from './slots/modal-content';
import { ModalFooter } from './slots/modal-footer';
import { ModalTitle } from './slots/modal-title';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * ModalSlot component.
 *
 * @author Mikhail Siutsou
 * @function Modal
 * @category components
 * @param {ModalProps} modal props.
 * @return {JSX.Element} modal component.
 */
var Modal = function Modal(_ref) {
  var children = _ref.children,
      adminModal = _ref.adminModal;
  var childrenArray = Children.toArray(children);
  var title = useMemo(function () {
    return childrenArray.find(getValidChild(ModalTitle));
  }, [childrenArray]);
  var content = useMemo(function () {
    return childrenArray.find(getValidChild(ModalContent));
  }, [childrenArray]);
  var footer = useMemo(function () {
    return childrenArray.find(getValidChild(ModalFooter));
  }, [childrenArray]);
  var buttons = useMemo(function () {
    return childrenArray.find(getValidChild(ModalButtons));
  }, [childrenArray]);
  return /*#__PURE__*/_jsxs(StyledModalContainer, {
    adminModal: adminModal,
    children: [title && /*#__PURE__*/_jsx(ModalTitle, _objectSpread(_objectSpread({}, title.props), {}, {
      adminModal: adminModal,
      children: title.props.children
    })), content && /*#__PURE__*/_jsx(ModalContent, _objectSpread(_objectSpread({}, content.props), {}, {
      adminModal: adminModal,
      children: content.props.children
    })), footer && /*#__PURE__*/_jsx(ModalFooter, _objectSpread(_objectSpread({}, footer.props), {}, {
      children: footer.props.children
    })), buttons && /*#__PURE__*/_jsx(ModalButtons, _objectSpread({}, buttons.props))]
  });
};

Modal.Title = ModalTitle;
Modal.Content = ModalContent;
Modal.Footer = ModalFooter;
Modal.Button = ModalButtons;
export { Modal };